import React from 'react';
import { AlertTriangle } from 'lucide-react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error: error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
        this.setState({ error: error, errorInfo: errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4">
                    <div className="bg-white rounded-xl p-6 shadow-2xl max-w-lg w-full border border-red-200">
                        <div className="flex items-center gap-3 mb-4 text-red-600">
                            <AlertTriangle size={32} />
                            <h2 className="text-xl font-bold">Oups, une erreur est survenue</h2>
                        </div>

                        <p className="text-slate-600 mb-4 font-medium">
                            Désolé, la page a rencontré un problème inattendu.
                        </p>

                        <div className="bg-slate-100 p-4 rounded-lg overflow-auto max-h-48 text-xs font-mono text-slate-700 mb-6 border border-slate-200">
                            <p className="font-bold text-red-500 mb-2">{this.state.error && this.state.error.toString()}</p>
                            <pre className="whitespace-pre-wrap">{this.state.errorInfo && this.state.errorInfo.componentStack}</pre>
                        </div>

                        <button
                            onClick={() => window.location.reload()}
                            className="w-full py-3 bg-slate-900 text-white rounded-xl font-bold hover:bg-slate-800 transition shadow-lg"
                        >
                            Recharger la page
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
